<h1 class="no-result">
    <div i18n="@@hermes-global-translations.oops!" class="heading-2 display-light"> Oops! </div>
    <div class="sub-title paragraph-medium">
        <ng-content></ng-content>
    </div>
</h1>
